import { IAppConfig } from '../interface/IAppConfig';

export const AppConfigService = (_apiAwsHost: string | null): IAppConfig => {
  const context = window.topContext;
  const siteConfig = context.config.getSiteConfig();
  const endpointConfig = context.config.getEndpointConfig();
  const apiAwsHost = _apiAwsHost || endpointConfig.apiAwsHost;

  return {
    apiGatewayBase: apiAwsHost + '/proxy',
    appName: 'onsa-travel',
    baseName: '/',
    environment: siteConfig.environment,
    logLevel: siteConfig.logLevel,
    logger: endpointConfig.logger,
    objectCacheUrl: endpointConfig.apiAwsHost + '/objects/',
    resourceBundles: {},
    resourceBundleApiUrl: endpointConfig.resourceBundle,
    contentBlocks: {},
    contentBlockApiUrl: endpointConfig.htmlContent,
    wso2ApiHost: endpointConfig.wso2host,
    wso2ApiUrl: apiAwsHost + '/proxy/v2/onlinesales-services/api',
    wso2OpenApiUrl: apiAwsHost + '/proxy/v2/openapi/onlinesales-services/api'
  };
};
